import {
  FaCheckCircle,
  FaClock,
  FaMoneyCheckAlt,
  FaMusic,
  FaTimesCircle,
} from "react-icons/fa";
import { STATUS } from "../../components/constants/statuses";

export const renderRequestTracker = (status) => {
  const isRejected = status === STATUS.REJECTED;

  const baseSteps = isRejected
    ? [
        { label: "Pending", icon: <FaClock />, key: STATUS.PENDING },
        { label: "Rejected", icon: <FaTimesCircle />, key: STATUS.REJECTED },
      ]
    : [
        { label: "Pending", icon: <FaClock />, key: STATUS.PENDING },
        { label: "Approved", icon: <FaCheckCircle />, key: STATUS.APPROVED },
        { label: "Paid", icon: <FaMoneyCheckAlt />, key: STATUS.PAID },
        { label: "Played", icon: <FaMusic />, key: STATUS.PLAYED },
      ];

  const steps = isRejected
    ? [
        ...baseSteps,
        { label: "", icon: null, key: "placeholder-1", placeholder: true },
        { label: "", icon: null, key: "placeholder-2", placeholder: true },
      ]
    : baseSteps;

  const currentIndex = steps.findIndex((step) => step.key === status);

  return (
    <div className="mt-6 flex justify-start">
      <div className="flex justify-between items-center px-2 w-full max-w-md">
        {steps.map((step, index) => {
          const isCurrentOrPassed = index <= currentIndex;
          const isPlaceholder = step.placeholder;

          const colorClass = isPlaceholder
            ? "bg-transparent border-transparent"
            : isRejected
            ? index === 0
              ? "bg-green-500 border-green-500"
              : index === 1
              ? "bg-red-500 border-red-500"
              : "bg-gray-600 border-gray-600"
            : isCurrentOrPassed
            ? "bg-green-500 border-green-500"
            : "bg-gray-600 border-gray-600";

          return (
            <div
              key={step.key}
              className="flex flex-col items-center text-xs z-10"
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-full border-2 text-white text-lg mb-1 ${colorClass}`}
              >
                {step.icon}
              </div>
              <span className="text-white text-[10px] sm:text-xs text-center whitespace-nowrap">
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
